import { apiRequest } from "./apiClient";

type SuccessListResponse = {
  readonly success?: boolean;
  readonly data: string[];
};

export const fetchLocationStates = async (): Promise<string[]> => {
  const response = await apiRequest("/location-reference/states");
  const json = (await response.json()) as SuccessListResponse;
  return Array.isArray(json.data) ? json.data : [];
};

export const fetchLocationCities = async (state: string): Promise<string[]> => {
  const sp = new URLSearchParams({ state });
  const response = await apiRequest(`/location-reference/cities?${sp.toString()}`);
  const json = (await response.json()) as SuccessListResponse;
  return Array.isArray(json.data) ? json.data : [];
};

export const fetchLocationZips = async (state: string, city: string): Promise<string[]> => {
  const sp = new URLSearchParams({ state, city });
  const response = await apiRequest(`/location-reference/zips?${sp.toString()}`);
  const json = (await response.json()) as SuccessListResponse;
  return Array.isArray(json.data) ? json.data : [];
};
